import { Observable } from "rxjs";
import { Page } from "../../page";
import { CriteriaSearchComponent } from "./criteria-search.component";

export abstract class StringCriteriaSearchComponent extends CriteriaSearchComponent<string> {
  
  constructor(displayName: string, onSearch: (query: string) => Observable<Page<string>>) {
    super(displayName, onSearch);
  }

  public formatResult(result: string): string {
    return result;
  }
}